import { MULTI_ENTITY_ENABLED } from './features';

export const MODULE_KEYS = [
  'movimientos',
  'facturas_compra',
  'facturas_venta',
  'justificantes',
  'bancos',
  'presupuesto',
  'proyectos',
  'subvenciones',
  'informes',
  'clientes',
  'proveedores',
  'inventario',
  'archivos',
  'refacturaciones',
  'grupos_scout',
  'becas',
] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

export type ModuleCatalogItem = {
  key: ModuleKey;
  label: string;
  description: string;
  group: string;
};

export const MODULE_CATALOG: ModuleCatalogItem[] = [
  { key: 'movimientos', label: 'Movimientos', description: 'Libro de tesorería e ingresos/gastos.', group: 'Operativa' },
  { key: 'facturas_compra', label: 'Facturas de compra', description: 'Registro de facturas recibidas.', group: 'Operativa' },
  { key: 'facturas_venta', label: 'Facturas de venta', description: 'Emisión y seguimiento de facturas emitidas.', group: 'Operativa' },
  { key: 'justificantes', label: 'Justificantes', description: 'Documentos de soporte de movimientos.', group: 'Operativa' },
  { key: 'bancos', label: 'Bancos y caja', description: 'Cuentas, extractos y movimientos bancarios.', group: 'Bancos' },
  { key: 'presupuesto', label: 'Presupuesto', description: 'Presupuesto por ejercicio y partidas.', group: 'Control' },
  { key: 'proyectos', label: 'Proyectos', description: 'Seguimiento de proyectos y ejecución.', group: 'Control' },
  { key: 'subvenciones', label: 'Subvenciones', description: 'Justificación y control de ayudas.', group: 'Control' },
  { key: 'becas', label: 'Programa de Becas', description: 'Programas, solicitudes y pago de becas a grupos scout.', group: 'Control' },
  { key: 'informes', label: 'Informes', description: 'Comprobación de saldos y cuadre de tesorería.', group: 'Control' },
  { key: 'clientes', label: 'Clientes', description: 'Contactos CRM de tipo cliente.', group: 'CRM' },
  { key: 'proveedores', label: 'Proveedores', description: 'Contactos CRM de tipo proveedor.', group: 'CRM' },
  { key: 'grupos_scout', label: 'Grupos scout', description: 'Grupos, facturas, movimientos y estado deudor.', group: 'CRM' },
  { key: 'inventario', label: 'Inventario', description: 'Catálogo de material, reservas y stock.', group: 'Sistema' },
  { key: 'archivos', label: 'Gestor de archivos', description: 'Archivos compartidos y bandeja documental.', group: 'Sistema' },
  { key: 'refacturaciones', label: 'Refacturaciones', description: 'Transferencias de gastos entre grupos.', group: 'Control' },
];

export const DEFAULT_MODULES: Record<ModuleKey, boolean> = {
  movimientos: true,
  facturas_compra: true,
  facturas_venta: false,
  justificantes: false,
  bancos: true,
  presupuesto: true,
  proyectos: true,
  subvenciones: true,
  informes: true,
  clientes: false,
  proveedores: true,
  inventario: true,
  archivos: false,
  refacturaciones: true,
  grupos_scout: true,
  becas: true,
};

export function visibleModuleCatalog(): ModuleCatalogItem[] {
  return MODULE_CATALOG.filter((item) => {
    if (item.key === 'refacturaciones') {
      return MULTI_ENTITY_ENABLED;
    }
    return true;
  });
}

export function firstEnabledCrmPath(isEnabled: (key: ModuleKey) => boolean): string {
  if (isEnabled('grupos_scout')) return '/admin/crm/grupos-scout';
  if (isEnabled('becas')) return '/admin/crm/personas';
  if (isEnabled('clientes')) return '/admin/crm/clientes';
  if (isEnabled('proveedores')) return '/admin/crm/proveedores';
  return '/admin/tesoreria';
}
